import { render } from "./WhyTrust.vue?vue&type=template&id=0cf2f78a&scoped=true"
import script from "./WhyTrust.vue?vue&type=script&lang=js"
export * from "./WhyTrust.vue?vue&type=script&lang=js"

import "./WhyTrust.vue?vue&type=style&index=0&id=0cf2f78a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\admin\\Desktop\\Расчосков\\rascheskov_katarakta_lending\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf2f78a"]])

export default __exports__